<script>
  import { onMount } from 'svelte';
  import { scale, fade } from 'svelte/transition';
  import theme from '../theme.js';

  export let x, y;

  let cloudEl;

  const person = {
    x: x,
    y: y,
  };

  // Watch x / y changes
  $: if (x || y) {
    if (cloudEl) {
      cloudEl.style.left = x + '%';
      cloudEl.style.top = y + '%';
    }
  }

  onMount(() => {
    cloudEl.style.top = y + '%';
    cloudEl.style.left = x + '%';
  });
</script>

<style type="text/postcss">
  .cloud {
    position: absolute;
    height: 12%;
    width: 12%;
    margin-left: -6%;
    margin-top: -6%;
    border-radius: 100%;
    overflow: visible;
    z-index: 0;
  }
</style>

<div
  bind:this="{cloudEl}"
  class="cloud"
  style="background: {theme.dashboard.background}"
  in:scale
  out:fade="{{ duration: 800 }}"></div>
